import { useEditCardForm, useEditCardFormLogic } from '../model';
import { Loader, ModalComponentWrapper } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { useConfirmationModal } from '@/widgets';
import { useCardPaymentSystems, type SavedCard } from '@/entities/card';
import { EditCardForm } from './EditCardForm';

type Props = {
  savedCard: SavedCard;
  onBack: () => void;
};

export const EditCardModal = ({ savedCard, onBack }: Props) => {
  const { t } = useTranslation();
  const { openModal, Modal: ConfirmationModal } = useConfirmationModal();

  const { form } = useEditCardForm({ savedCard });
  const { data: paymentSystems, isLoading } = useCardPaymentSystems();

  const { updateCard, deleteCard, isPending } = useEditCardFormLogic({
    form,
    templateId: savedCard.templateId,
    onSuccess: onBack,
    openConfirmationModal: openModal,
  });

  return (
    <ModalComponentWrapper
      title={t('savedAddresses.card.editing.title')}
      onBack={onBack}>
      {isLoading && <Loader />}

      {!isLoading && (
        <EditCardForm
          form={form}
          paymentSystems={paymentSystems}
          updateCard={updateCard}
          deleteCard={deleteCard}
          isPending={isPending}
        />
      )}

      {ConfirmationModal}
    </ModalComponentWrapper>
  );
};
